import { useScrollAnimation } from '../hooks/useScrollAnimation';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const faqItems = [
  {
    question: 'What types of healthcare staffing services do you provide?',
    answer:
      'We offer a wide range of staffing solutions including Travel Staffing, Local Contracts & Per Diem, Direct Hire, Managed Services, Crisis & Rapid Response Staffing, and Telehealth Support Staffing—designed to meet both short-term and long-term needs.',
  },
  {
    question: 'How quickly can you provide staff in urgent situations?',
    answer:
      'Through our Crisis & Rapid Response service, we can deploy qualified professionals within hours, ensuring your facility remains fully supported during emergencies or sudden demand surges.',
  },
  {
    question: 'Do you work with both clinical and non-clinical professionals?',
    answer:
      'Yes. We specialize in connecting highly qualified nursing, allied health, and non-clinical professionals with healthcare facilities nationwide.',
  },
  {
    question: 'What values guide your staffing process?',
    answer:
      'Our work is built on four core values: Integrity, Compassion, Excellence, and Collaboration—ensuring ethical practices, empathy in service, high standards, and strong partnerships.',
  },
  {
    question: 'Can you support virtual care and telehealth programs?',
    answer:
      'Absolutely. Our Telehealth Support Staffing service provides both clinical and administrative staff to help organizations build and scale their virtual care operations.',
  },
];

export const FAQ = () => {
  const [titleRef, titleVisible] = useScrollAnimation();
  const [accordionRef, accordionVisible] = useScrollAnimation();

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="section-padding bg-white"
    >
      <div className="container-width">
        {/* Section Header */}
        <div
          ref={titleRef}
          className={`text-center mb-16 animate-on-scroll ${titleVisible ? 'visible' : ''}`}
        >
          <span className="inline-block text-sm font-medium tracking-widest uppercase text-primary/60 mb-4">
            Frequently Asked Questions
          </span>
          <h2 className="text-4xl md:text-5xl font-semibold tracking-tight text-primary">
            Your Questions, Answered
          </h2>
        </div>

        {/* FAQ Accordion */}
        <div
          ref={accordionRef}
          className={`max-w-3xl mx-auto animate-on-scroll ${accordionVisible ? 'visible' : ''}`}
        >
          <Accordion
            type="single"
            collapsible
            className="w-full"
            data-testid="faq-accordion"
          >
            {faqItems.map((item, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="border-b border-border/50"
                data-testid={`faq-item-${index}`}
              >
                <AccordionTrigger className="faq-trigger text-left font-semibold text-foreground hover:text-primary">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="pb-6 text-muted-foreground leading-relaxed">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
